import { Button, Modal, Table } from 'antd';
import _ from 'lodash';
import React, { useState, useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { useRecoilState } from 'recoil';
import { reportModalAtom, notificationsAtom } from '../../../../../atoms/Atoms';
import { H1 } from '../../../../shared-components/typography/Title';
import api from '../../../../../api/api';
import { thousand, thousandAutoDecimal } from '../../../../../functions';

function WattsSoldModal() {
  const { t } = useTranslation();
  const [reportModal, setReportModal] = useRecoilState(reportModalAtom);
  const [notifications, setNotifications] = useRecoilState(notificationsAtom);
  const [loading, setLoading] = useState(false);
  const [data, setData] = useState([]);

  function getData() {
    setLoading(true);
    let url = 'reports/wattssold';
    if (reportModal?.orgReferralCode) {
      url += `?orgCode=${reportModal?.orgReferralCode}`;
    }
    if (reportModal?.forSetter) {
      if (url.endsWith('wattssold')) {
        url += '?forSetters=true';
      } else {
        url += '&forSetters=true';
      }
    }
    api.get(url)
      .then((response) => {
        setLoading(false);
        if (response.data.success) {
          setData(response.data.data);
        } else {
          setNotifications([
            ...notifications,
            {
              title: t('error'),
              description: response?.data?.error,
              error: true,
            },
          ]);
        }
      })
      .catch((error) => {
        setLoading(false);
        setNotifications([
          ...notifications,
          {
            title: t('error'),
            description: error?.message,
            error: true,
          },
        ]);
      });
  }

  useEffect(() => {
    if (reportModal?.type === 'watts_sold') {
      getData();
    }
  }, [reportModal]);

  return (
    <Modal
      footer={null}
      width="100%"
      open={reportModal?.type === 'watts_sold'}
      onCancel={() => setReportModal(null)}
    >
        <div className="flex mt-8">
          <H1 text={t('watts_sold')} className="mr-auto" />
          <Button
            size="small"
            type="primary"
            onClick={() => getData()}
          >
            {t('reload')}
          </Button>
        </div>
        <Table
          loading={loading}
          bordered
          pagination={{ showSizeChanger: true }}
          dataSource={data}
          columns={[
            {
              title: '',
              align: 'left',
              className: 'text-sm w-full md:hidden',
              render: (row) => (
                <div className="grid grid-cols-2 gap-2 w-full">
                  <div className="col-span-2 text-center">
                    <p>{row?.user?.completeName}</p>  
                  </div>
                  <div className="col-span-1 text-left">
                    <p className="font-bold">{t('signed_watts_total')}</p>
                    <p>{thousandAutoDecimal(row.signedWatts, 2)} {t('watts')} ({thousand(row.signed, 0)})</p>
                  </div>
                  <div className="col-span-1 text-right">
                    <p className="font-bold">{t('installed_watts_total')}</p>
                    <p>{thousandAutoDecimal(row.installedWatts, 2)} {t('watts')} ({thousand(row.installed, 0)})</p>
                  </div>
                </div>
              )
            },
            {
              title: t('closer'),
              align: 'left',
              className: 'text-sm hidden md:table-cell',
              sorter: (a, b) => a.user?.completeName.toLocaleLowerCase().localeCompare(b.user?.completeName.toLocaleLowerCase()),
              render: (row) => (
                <>
                  <p>{row?.user?.completeName}</p>
                </>
              ),
            },
            {
              title: t('signed_watts_total'),
              align: 'left',
              className: 'text-sm hidden md:table-cell',
              sorter: (a, b) => a.signedWatts - b.signedWatts,
              render: (row) => (
                <>
                  <p>{thousandAutoDecimal(row.signedWatts, 2)} {t('watts')} ({thousand(row.signed, 0)})</p>
                </>
              ),
            },
            {
              title: t('installed_watts_total'),
              align: 'left',
              className: 'text-sm hidden md:table-cell',
              sorter: (a, b) => a.installedWatts - b.installedWatts,
              render: (row) => (
                <>
                  <p>{thousand(row.installedWatts, 2)} {t('watts')} ({thousand(row.installed, 0)})</p>
                </>
              ),
            },
          ]}
        />
    </Modal>
  )
}

export default WattsSoldModal;
